import { Service, inject } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleService} from './google-service';
import {environment} from '../../environments/environment';
import {Entity} from '../entity/entity';
import {Observable} from 'rxjs';
import {EntityHeader} from '../entity/entity-header';
import {ScheduleLineInput} from '../model/schedule-line-input';
import {EntitySearchCriteria} from '../entity/entity-search-criteria';
import {ScheduleSharingInput} from '../model/schedule-sharing-input';

@Service()
export class ScheduleService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'schedules/';

  createSchedule(input: Entity): Observable<Entity> {
    const url = this.urlBase + 'create';
    return this.http.post<Entity>(url, JSON.stringify(input), {headers: this.getPostHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  updateSchedule(schedule: Entity): Observable<Entity> {
    const url = this.urlBase + 'update';
    return this.http.post<Entity>(url, JSON.stringify(schedule), {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }

  search(criteria: EntitySearchCriteria): Observable<EntityHeader[]> {
    const url = this.urlBase + 'search';
    return this.http.post<EntityHeader[]>(url, JSON.stringify(criteria), {headers: this.getPostHeaders()});
  }

  getSchedule(id: string): Observable<Entity> {
    const url = this.urlBase + id;
    return this.http.get<Entity>(url, {headers: this.getRequestHeaders()});
  }

  addLineToSchedule(input: ScheduleLineInput): Observable<Entity> {
    const url = this.urlBase + 'addLine';
    const headers = this.getPostHeaders();
    const body = JSON.stringify(input);
    return this.http.post<Entity>(url, body, {headers: headers});
  }

  deleteLine(scheduleId: string, lineId: string): Observable<string> {
    const url = this.urlBase + 'line/' + scheduleId + '/' + lineId;
    return this.http.delete(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  getScheduleLineDetail(scheduleId: string, lineId: string): Observable<ScheduleLineInput> {
    const url = this.urlBase + 'lineDetail/' + scheduleId + '/' + lineId;
    return this.http.get<ScheduleLineInput>(url, {headers: this.getRequestHeaders()});
  }

  updateLine(input: ScheduleLineInput): Observable<string> {
    const url = this.urlBase + 'updateLine';
    const headers = this.getPostHeaders();
    return this.http.post(url, JSON.stringify(input), {headers: headers, responseType: 'text'});
  }

  requestQuote(input: ScheduleSharingInput): Observable<string> {
    const url = this.urlBase + 'requestQuote';
    const headers = this.getPostHeaders();
    return this.http.post(url, JSON.stringify(input), {headers: headers, responseType: 'text'});
  }

  getRequestedQuoteId(scheduleId: string): Observable<string> {
    const url = this.urlBase + 'requestedQuoteId/' + scheduleId;
    return this.http.get(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  shareSchedule(input: ScheduleSharingInput): Observable<string> {
    const url = this.urlBase + 'share';
    const headers = this.getPostHeaders();
    return this.http.post(url, JSON.stringify(input), {headers: headers, responseType: 'text'});
  }

}
